export default __webpack_public_path__ + "static/media/692.d9562958.gif";